"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var CabinCategory = /** @class */ (function () {
    // create a new Cabin Oject based on the similar CabinOptions
    function CabinCategory(ccData, ccAdditional, varioAICCList, shipCode) {
        this.varioAICategories = [];
        this.code = ccData.id;
        this.head = ccData.head;
        if (ccData.mainDescription) {
            this.description = ccData.mainDescription;
            this.displayDescription = this.description.lines;
        }
        this.amenities = ccData.amenities || [];
        this.available = ccData.available;
        this.img = ccData.image;
        this.maxOcc = ccData.occupancy.max || 0;
        this.minOcc = ccData.occupancy.min || 0;
        this.price = ccData.price ? ccData.price : 0;
        this.name = ccData.mainName;
        this.displayName = this.displayNameFN();
        this.surcharges = ccData.surcharges;
        this.pricingsPerPax = ccData.pricings;
        this.shipCode = shipCode;
        this.surchargeEB = lodash_1.reduce(this.surcharges, function (sum, surcharge) {
            if (surcharge.type === 'EB') {
                sum = sum + surcharge.amount;
            }
            return sum;
        }, 0);
        this.surchargeEBP = lodash_1.reduce(this.surcharges, function (sum, surcharge) {
            if (surcharge.type === 'EBP') {
                sum = sum + surcharge.amount;
            }
            return sum;
        }, 0);
        this.varioAIAvailable = false;
        if (varioAICCList && varioAICCList.length > 0) {
            this.varioAIAvailable = varioAICCList[0].available === true ? true : false;
            this.cheapestVarioAIprice = varioAICCList[0].price;
            for (var _i = 0, varioAICCList_1 = varioAICCList; _i < varioAICCList_1.length; _i++) {
                var varioAICategory = varioAICCList_1[_i];
                this.varioAICategories.push(new CabinCategory(varioAICategory, null, null, shipCode));
            }
        }
        if (ccAdditional) {
            this.premiumCategories = [];
            this.premiumAICategories = [];
            for (var _a = 0, ccAdditional_1 = ccAdditional; _a < ccAdditional_1.length; _a++) {
                var additionalCategory = ccAdditional_1[_a];
                if (additionalCategory.priceModel === 'PREMIUM') {
                    this.premiumCategories.push(new CabinCategory(additionalCategory, null, null, shipCode));
                }
                if (additionalCategory.priceModel === 'PREMIUMAI') {
                    this.premiumAICategories.push(new CabinCategory(additionalCategory, null, null, shipCode));
                }
            }
            var premiumCategories = lodash_1.partition(this.premiumCategories, function (category) {
                return category.available;
            });
            var premiumAICategories = lodash_1.partition(this.premiumAICategories, function (category) {
                return category.available;
            });
            this.premiumCategories = lodash_1.concat(lodash_1.sortBy(premiumCategories[0], function (cabin) {
                return cabin.price;
            }), lodash_1.sortBy(premiumCategories[1], function (cabin) {
                return cabin.price ? cabin.price : Infinity;
            }));
            this.premiumAICategories = lodash_1.concat(lodash_1.sortBy(premiumAICategories[0], function (cabin) {
                return cabin.price;
            }), lodash_1.sortBy(premiumAICategories[1], function (cabin) {
                return cabin.price ? cabin.price : Infinity;
            }));
            this.premiumAvailable = false;
            for (var _b = 0, _c = this.premiumCategories; _b < _c.length; _b++) {
                var premiumCabinCategory = _c[_b];
                if (premiumCabinCategory.available === true) {
                    this.premiumAvailable = true;
                    break;
                }
            }
            var minPremiumCabinCategory = lodash_1.minBy(lodash_1.filter(this.premiumCategories, 'available'), 'price');
            if (minPremiumCabinCategory) {
                this.cheapestPremiumPrice = minPremiumCabinCategory.price;
            }
            this.premiumAIAvailable = false;
            for (var _d = 0, _e = this.premiumAICategories; _d < _e.length; _d++) {
                var premiumAICabinCategory = _e[_d];
                if (premiumAICabinCategory.available === true) {
                    this.premiumAIAvailable = true;
                    break;
                }
            }
            var minPremiumAICabinCategory = lodash_1.minBy(lodash_1.filter(this.premiumAICategories, 'available'), 'price');
            if (minPremiumAICabinCategory) {
                this.cheapestPremiumAIPrice = minPremiumAICabinCategory.price;
            }
        }
        this.mainCode = ccData.mainID;
    }
    // format junk from the name for display
    CabinCategory.prototype.displayNameFN = function () {
        if (/\s\|\s/.test(this.name)) {
            var name_1 = this.name.split(' | ')[1];
            if (name_1.includes('[')) {
                return name_1.slice(0, -5);
            }
            return name_1;
            // return this.name.split(' | ')[1].slice(0,-5)
        }
        else {
            return this.name;
        }
    };
    return CabinCategory;
}());
exports.CabinCategory = CabinCategory;
//# sourceMappingURL=cabin_category.js.map